import { CalendarProps, SingleCalendarProps } from '../type/BaseCalendarType';

export const isSingleMode = (props: CalendarProps): props is SingleCalendarProps => {
  return props?.mode !== 'multiple';
};
